import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery("");
    }
  };

  return (
    <nav className="bg-[var(--dark)] text-white sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="text-2xl font-bold flex items-center">
              <i className="fa-solid fa-robot mr-2 text-[var(--accent)]"></i>
              <span>AI Tools Hub</span>
            </Link>
            
            <div className="hidden md:flex space-x-6">
              <Link 
                to="/categories" 
                className="hover:text-[var(--accent)] transition-colors font-medium"
              >
                Categories
              </Link>
              <Link 
                to="/new" 
                className="hover:text-[var(--accent)] transition-colors font-medium"
              >
                New Tools
              </Link>
              <Link 
                to="/popular" 
                className="hover:text-[var(--accent)] transition-colors font-medium"
              >
                Popular
              </Link>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <form onSubmit={handleSearchSubmit} className="relative hidden md:block">
              <input 
                type="text" 
                placeholder="Search tools..." 
                value={searchQuery}
                onChange={handleSearchChange}
                className="pl-4 pr-10 py-2 rounded-full bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-[var(--accent)] w-64 placeholder-gray-400"
              />
              <button type="submit" className="absolute right-3 top-3 text-gray-400 hover:text-[var(--accent)]">
                <i className="fa-solid fa-search"></i>
              </button>
            </form>
            
            <button 
              className="md:hidden text-gray-300 hover:text-white"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`fa-solid fa-${isMenuOpen ? 'xmark' : 'bars'} text-xl`}></i>
            </button>
          </div>
        </div>
        
        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-gray-900 px-4 py-3 space-y-2">
            <form onSubmit={handleSearchSubmit} className="relative mb-2">
              <input 
                type="text" 
                placeholder="Search tools..." 
                value={searchQuery}
                onChange={handleSearchChange}
                className="w-full pl-4 pr-10 py-2 rounded bg-gray-800 text-white focus:outline-none"
              />
              <button type="submit" className="absolute right-3 top-3 text-gray-400 hover:text-[var(--accent)]">
                <i className="fa-solid fa-search"></i>
              </button>
            </form>
            <Link 
              to="/categories" 
              className="block hover:bg-gray-800 px-3 py-2 rounded transition-colors"
            >
              Categories
            </Link>
            <Link 
              to="/new" 
              className="block hover:bg-gray-800 px-3 py-2 rounded transition-colors"
            >
              New Tools
            </Link>
            <Link 
              to="/popular" 
              className="block hover:bg-gray-800 px-3 py-2 rounded transition-colors"
            >
              Popular
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}